var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('p',[_c('span',{staticClass:"loading__text"},[_vm._v(" Loading ")]),_c('span',{staticClass:"loading__dots"})])])
}]

export { render, staticRenderFns }